// @ts-nocheck
export class Sprite {
    oam;
    index;
    constructor(oam, spriteNumber) {
        this.oam = oam;
        this.index = spriteNumber * 4;
    }
    get y() {
        return this.oam[this.index];
    }
    get x() {
        return this.oam[this.index + 1];
    }
    get tile() {
        return this.oam[this.index + 2];
    }
    get flags() {
        return this.oam[this.index + 3];
    }
}
//# sourceMappingURL=sprite.js.map